// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"MobileActionsHistoryTopBar_top_bar__2hwt8","proposal_button":"MobileActionsHistoryTopBar_proposal_button__Cig1F","active":"MobileActionsHistoryTopBar_active__22hTH"};